const MONTHS_ES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

export const formatPeriod = (periodFrom, periodTo) => {
  if (!periodFrom || !periodTo) return '';
  const from = new Date(periodFrom + 'T00:00:00');
  const to = new Date(periodTo + 'T00:00:00');
  if (from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
    return `${MONTHS_ES[from.getMonth()]} ${from.getFullYear()}`;
  }
  return `${MONTHS_ES[from.getMonth()]} ${from.getFullYear()} – ${MONTHS_ES[to.getMonth()]} ${to.getFullYear()}`;
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  }).format(value);
};

export const formatDate = (date) => {
  return new Date(date + 'T00:00:00').toLocaleDateString('es-MX');
};

export const getInvoiceStatusColor = (status) => {
  const statusMap = {
    draft: 'default',
    issued: 'processing',
    scheduled: 'warning',
    partially_paid: 'warning',
    paid: 'success',
    overdue: 'error',
    cancelled: 'default',
  };
  return statusMap[status] || 'default';
};

export const getPaymentStatusColor = (status) => {
  const statusMap = {
    pending: 'warning',
    confirmed: 'success',
    rejected: 'error',
  };
  return statusMap[status] || 'default';
};

export const getInvoiceStatusLabel = (status) => {
  const statusMap = {
    draft: 'Borrador',
    issued: 'Emitida',
    scheduled: 'Programada',
    partially_paid: 'Parcialmente Pagada',
    paid: 'Pagada',
    overdue: 'Vencida',
    cancelled: 'Cancelada',
  };
  return statusMap[status] || status;
};

export const getPaymentStatusLabel = (status) => {
  const statusMap = {
    pending: 'Pendiente',
    confirmed: 'Confirmado',
    rejected: 'Rechazado',
  };
  return statusMap[status] || status;
};

export const getPaymentMethodLabel = (method) => {
  const methodMap = {
    bank_transfer: 'Transferencia Bancaria',
    check: 'Cheque',
    credit_card: 'Tarjeta de Crédito',
    cash: 'Efectivo',
    other: 'Otro',
  };
  return methodMap[method] || method;
};

export const getCustomerStatusColor = (status) => {
  const statusMap = {
    active: 'success',
    inactive: 'default',
    suspended: 'error',
  };
  return statusMap[status] || 'default';
};

export const getCustomerStatusLabel = (status) => {
  const statusMap = {
    active: 'Activo',
    inactive: 'Inactivo',
    suspended: 'Suspendido',
  };
  return statusMap[status] || status;
};

export const getTemplateTypeLabel = (type) => {
  const typeMap = {
    reminder: 'Recordatorio',
    overdue: 'Vencimiento',
    payment_received: 'Pago Recibido',
    custom: 'Personalizado',
  };
  return typeMap[type] || type;
};

export const getEmailStatusColor = (status) => {
  const statusMap = {
    scheduled: 'processing',
    sent: 'success',
    failed: 'error',
    cancelled: 'default',
  };
  return statusMap[status] || 'default';
};

export const getEmailStatusLabel = (status) => {
  const statusMap = {
    scheduled: 'Programado',
    sent: 'Enviado',
    failed: 'Fallido',
    cancelled: 'Cancelado',
  };
  return statusMap[status] || status;
};
